import { getButtonProps } from "./shared.js";
import textbutton_module_default from "./textbutton.module.js";
import { Button } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/button/TextButton.tsx
const WRAP_STYLES = {
	root: { height: "auto" },
	label: {
		whiteSpace: "normal",
		overflow: "visible",
		height: "auto"
	}
};
const TextButton = ({ children, LeftIcon, RightIcon, color = "primary", justify = "center", disabled, wrap = false, "data-testid": testId, size = "md", ...restProps }) => {
	return /* @__PURE__ */ jsx(Button, {
		...getButtonProps(restProps),
		variant: "transparent",
		size,
		color,
		classNames: textbutton_module_default,
		styles: wrap ? WRAP_STYLES : void 0,
		disabled,
		rightSection: RightIcon && /* @__PURE__ */ jsx(RightIcon, { color }),
		leftSection: LeftIcon && /* @__PURE__ */ jsx(LeftIcon, { color }),
		__vars: {
			"--button-hover-color": `var(--mantine-color-${color}-9)`,
			"--button-justify": justify
		},
		"data-testid": testId,
		children
	});
};

//#endregion
export { TextButton };